<template>
    <div class="position-relative p-1 mt-3 search-width">
      <button type="button" class="btn btn-default position-absolute start-0 bg-none border-0"><i class="fa fa-search fa-fw"></i></button>
      <input type="text" class="form-control ps-5 rounded-2 fw-normal" placeholder="Search..." aria-label="Search..." v-model="searchInput">
    </div>
  </template>

  <script>
  export default {
    name: 'Search',
    data() {
      return {
        searchInput: null,
      }
    },
    watch: {
      searchInput: function(val) {
        this.$emit('searchText', val.trim()); // Emit the searchText event with trimmed value
      },
    },
  }
  </script>
<style>
  .search-width{
    width : 25% !important;
  }

@media (max-width: 1100px){
  .search-width{
    width: 40%!important;
  }
}
@media (max-width: 900px){
  .search-width{
    width: 50%!important;
  }
}
@media (max-width: 700px){
  .search-width{
    width: 80%!important;
  }
}
@media (max-width: 500px){
  .search-width{
    width: 90%!important;   
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Search.vue